module.exports = __webpack_public_path__ + "img/summon-btn-active.8b66300b.png";